import React, { useEffect, useRef } from "react";
import { TextContainer, Paragraph } from "../styles/components/Global/Text";
import animations from "./Animations";

const HightlightText = ({ align }) => {
  const containerRef = useRef(null);
  useEffect(() => {
    setTimeout(() => {
      animations.parallax(containerRef.current);
    }, 1000);
  }, []);

  return (
    <TextContainer ref={containerRef} $align={align} $flex>
      <Paragraph
        $width="medium"
        $indent="true"
        $size="normal"
        $textAlign="left"
        $bold="true"
      >
        The{" "}
        <a
          href="https://www.lotuscars.com/eletre?utm_source=editorial23&utm_medium=PARTNERWEBSITE&utm_campaign=ELETRE_NA_Influencer_Q3_23&utm_content=HS-editorial"
          target="_blank"
        >
          Lotus Eletre
        </a>
        , the model on which this project is based, has a natural synthesis with
        the corefoundations of <span className="highlight">Ksawery’s </span>
        work. Both exhibit a forward-looking and technologically advanced
        approach, while also embracing a sense of heritage and collaboration
        with the aesthetic lineages from which they draw their respective
        inspiration. Additionally, Ksawery also drew inspiration from
        contemporary pop culture, infusing the interactive exhibit with elements
        that resonate with a modern audience. One such inspiration is the
        DeLorean time machine from Back to the Future, a modified DeLorean
        DMC-12 today is one of the most recognizable pieces of retro-futuristic
        technology. “It was one of my favorite movies as a kid, and still one of
        my favorites today,” according to Ksawery.
      </Paragraph>
    </TextContainer>
  );
};

export default HightlightText;
